import React, { useState } from 'react'
import { useSelector } from 'react-redux';

import thumb_point from '../../assets/images/call/thumb_point.svg';

const BuildingInformation = () => {
    const state = useSelector((state) => state.reducer)
    const [showMore, setShowMore] = useState(false);
    const inclusionText = state.const_var.editAPIDataByResponse.data?.building_inclusion_text2 || [];

    const preprocessText = (text) => {
        return text.replace(/"/g, '').replace(/'/g, '').replace('Lean-tos', "Lean-To's");
    };

    const Dot = () => {
        return (
            <img src={thumb_point} alt='img' />
        )
    }

    return (
        <div className='garage-category-container'>
            <div className='garage-category-note'>
                <span className='sm-show'><b>SKU:</b> {state.const_var.crmSetting.sku_id}</span>
                <h1>{state.const_var.new_building_name!=undefined && state.const_var.new_building_name}</h1>
                {/* <span className='sm-hidden'><b>SKU:</b> {state.const_var.crmSetting.sku_id}</span> */}
            </div>
            <div className='garage-category garage-category-wrap'>  
                <div className='prow'>
                    {
                        inclusionText.length > 0 && 
                        inclusionText.map((data, index) => {
                            return (
                                (window.innerWidth > 992 && window.innerWidth < 1280) ? 
                                    <>
                                        {
                                            index <= 3 &&  
                                                <div className='pcol-6 category-wrap'>
                                                    <Dot />
                                                    <div>
                                                        {preprocessText(data)}
                                                        {(index === 3 && !showMore)  && (<>...<span onClick={(e) => setShowMore(true)}>read more</span></>)}
                                                    </div>
                                                </div>
                                        }
                                        {
                                            (showMore && index > 3) &&  
                                                <div className='pcol-6 category-wrap'>
                                                    <Dot />
                                                    <div>
                                                        {preprocessText(data)}
                                                        {index === inclusionText.length-1 && (<>...<span onClick={(e) => setShowMore(false)}>less</span></>)}
                                                    </div>
                                                </div>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className='pcol-6 category-wrap'>
                                            <Dot />
                                            <div>
                                                {preprocessText(data)}
                                            </div>
                                        </div>
                                    </>
                            )
                        })
                    }
                </div>
            </div>
                
        </div>
    )
}

export default BuildingInformation;